// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__bHI-4","rootSmall":"AddTileButton_rootSmall__iN8n5"};